import React from 'react';
import PropTypes from 'prop-types';
import { labelStyle, checkboxStyle } from './styles';

class AudienceFilterComponent extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			...props,
		};
	}

	componentWillReceiveProps = ({ activeFilters }) => {
    this.setState({ activeFilters });
  };

	handleChange(event) {
		const target = event.target;
		const name = target.name;
		const index = this.state.activeFilters.indexOf(name);
		let activeFilters = [...this.state.activeFilters];
		if (index !== -1) {
			activeFilters.splice(index, 1);
		} else {
			activeFilters.push(name);
		}
		this.setState({
			activeFilters: activeFilters,
		});

		this.state.onChange(activeFilters);
	}

	render() {
		return (
			<div>
				{ this.state.audiences.map(audience => (
					<label key={ audience.id } className={ labelStyle }>
						<input
							type="checkbox"
							className={ checkboxStyle }
							checked={ this.state.activeFilters.includes(audience.id) }
							name={ audience.id }
							onChange={ this.handleChange.bind(this) }
						/>
						{ audience.icon }
						<span>{ audience.title }</span>
					</label>
				)) }
			</div>
		);
	}
}

AudienceFilterComponent.propTypes = {
	links: PropTypes.any,
};

export const AudienceFilter = AudienceFilterComponent;



// WEBPACK FOOTER //
// ./src/components/shared/audienceFilter/component.js